export class BusinessProcess {
  businessProcessId: number;
  name: string;
  version: string;
  id: number;
}
